export default __webpack_public_path__ + "static/broderie10.inspirations-9a2f98ca3e2cfafb188b252e124de83d.jpg";